import { createSlice } from "@reduxjs/toolkit";
import {
  getAllInstrumentGroups,
  getClientList,
  getClosedTrades,
  getDeals,
  getEquityReport,
  getMoneyTransferReport,
  getOpenPositions,
  getSubIbList,
  getTopClientReport,
  getOfficesInfo,
} from "./thunk";

export const initialState = {
  // Get Client List
  clientList: [],
  isListSuccess: false,
  // Get Closed Trades
  closedPositions: [],
  isListClosedPositionsSuccess: false,
  // Get Deals
  dealsData: [],
  isListDealsSuccess: false,
  dealsLoading:false,
  // Get Equity Report
  equityReports: [],
  isListEquityReportsSuccess: false,
  // Get Money Transfer Report
  moneyTransfers: [],
  isListMoneyTransfersSuccess: false,
  // Get Open Positions
  openPositions: [],
  isOpenPositionsSuccess: false,
  // Get SubIb List
  subIbList: [],
  isListSubIbListSuccess: false,
  // Get Top Client Report
  topClients: [],
  isListTopClientsSuccess: false,
  // Get All Instrument Groups
  allInstrumentGroups: [],
  getAllInstrumentGroupsSuccess: {},
  // Get Offices Info
  getOfficesInfoData: [],
  getOfficesInfoError: {},
  // Error Handling
  error: {},
};

const ReportSlice = createSlice({
  name: "ReportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Client List
    builder.addCase(getClientList.fulfilled, (state: any, action: any) => {
      state.clientList = action.payload;
      state.isListSuccess = true;
    });
    builder.addCase(getClientList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get Closed Trades
    builder.addCase(getClosedTrades.fulfilled, (state: any, action: any) => {
      state.closedPositions = action.payload;
      state.isListClosedPositionsSuccess = true;
    });
    builder.addCase(getClosedTrades.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get Deals
    builder.addCase(getDeals.pending, (state) => {
      state.dealsLoading = true;
      state.error = false;
    });
    builder.addCase(getDeals.fulfilled, (state: any, action: any) => {
      state.dealsData = action.payload;
      state.isListDealsSuccess = true;
      state.dealsLoading = false;
    });
    builder.addCase(getDeals.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.dealsLoading = false;
    });
    // Get Equity Report
    builder.addCase(getEquityReport.fulfilled, (state: any, action: any) => {
      state.equityReports = action.payload;
      state.isListEquityReportsSuccess = true;
    });
    builder.addCase(getEquityReport.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get Money Transfer Report
    builder.addCase(
      getMoneyTransferReport.fulfilled,
      (state: any, action: any) => {
        state.moneyTransfers = action.payload;
        state.isListMoneyTransfersSuccess = true;
      }
    );
    builder.addCase(
      getMoneyTransferReport.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
      }
    );
    // Get Open Positions
    builder.addCase(getOpenPositions.fulfilled, (state: any, action: any) => {
      state.openPositions = action.payload;
      state.isOpenPositionsSuccess = true;
    });
    builder.addCase(getOpenPositions.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.isOpenPositionsSuccess = false;
    });
    // Get SubIb List
    builder.addCase(getSubIbList.fulfilled, (state: any, action: any) => {
      state.subIbList = action.payload;
      state.isListSubIbListSuccess = true;
    });
    builder.addCase(getSubIbList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get Top Client Report
    builder.addCase(getTopClientReport.fulfilled, (state: any, action: any) => {
      state.topClients = action.payload;
      state.isListTopClientsSuccess = true;
    });
    builder.addCase(getTopClientReport.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
    });
    // Get All Instrument Groups
    builder.addCase(
      getAllInstrumentGroups.fulfilled,
      (state: any, action: any) => {
        state.allInstrumentGroups = action.payload;
        state.getAllInstrumentGroupsSuccess = true;
      }
    );
    builder.addCase(
      getAllInstrumentGroups.rejected,
      (state: any, action: any) => {
        state.allInstrumentGroups = action.error.message;
      }
    );
    // Get Offices Info
    builder.addCase(getOfficesInfo.fulfilled, (state: any, action: any) => {
      state.getOfficesInfoData = action.payload;
    });
    builder.addCase(getOfficesInfo.rejected, (state: any, action: any) => {
      state.getOfficesInfoError = action.error.message;
    });
  },
});

export default ReportSlice.reducer;
